import React, { PropsWithChildren } from 'react';
import { CookiesProvider } from 'react-cookie';
import NiceModal from '@ebay/nice-modal-react';
import IntlProvider from './IntlReduxProvider';
import RouterProvider from './RouterProvider';
import StoreProvider from './StoreProvider';

const Providers: React.FunctionComponent<PropsWithChildren> = ({ children }) => {
  return (
    <StoreProvider>
      <CookiesProvider>
        <IntlProvider>
          <NiceModal.Provider>
            <RouterProvider>{children}</RouterProvider>
          </NiceModal.Provider>
        </IntlProvider>
      </CookiesProvider>
    </StoreProvider>
  );
};

export default Providers;
